import React from 'react'

const BankChangeCustomerDetails = ({ customerData, oldAccountLastFour, oldAccountRouting, variant = 'grid' }) => {
  const fields = [
    { key: 'customer', label: 'Customer', value: customerData.name },
    { key: 'email', label: 'Email', value: <span className="lox-break-anywhere">{customerData.emailAddress}</span> },
    { key: 'new-account', label: 'New Account', value: `****${customerData.accountNumber} / ${customerData.routingNumber}` },
    { key: 'old-account', label: 'Old Account', value: `****${oldAccountLastFour} / ${oldAccountRouting}` },
  ]

  if (variant === 'stacked') {
    return (
      <div className="content is-small mb-3">
        {fields.map((field) => (
          <p className="mb-1" key={field.key}><strong>{field.label}:</strong> {field.value}</p>
        ))}
      </div>
    )
  }

  return (
    <div className="content is-small mb-1">
      <div className="columns mb-0">
        {fields.map((field) => (
          <div className="column is-3" key={field.key}>
            <p className="mb-1"><strong>{field.label}:</strong> {field.value}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default BankChangeCustomerDetails
